import axios from 'axios'
const getPaper = (parameter = {}) => {
    return new Promise((resolve, reject) => {
        let url = `pid-doi-service/paper.list?query=${parameter.title}&page=${parameter.pageNumber}&size=${parameter.pageSize}&year=${parameter.year}&identifier=${parameter.parse}` + "&sortFiled=" + parameter.sortFiled + "&order=" + parameter.order
        axios
            .get(url)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}
const getResource = (parameter = {}) => {
    return new Promise((resolve, reject) => {
        let url = "/pid-common-service/statistics/metadata.search.aggregation?" +
            "page=" +
            parameter.pageNumber +
            "&size=" +
            parameter.pageSize +
            "&query=" +
            parameter.container +
            "&resourceType=" +
            parameter.resourceName + "&publisher=" + parameter.publishName + "&personIdentifier=" + parameter.identifier + "&sortFiled=" + parameter.sortFiled + "&order=" + parameter.order + '&prefix=' + parameter.prefix
        axios
            .get(url)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })

    })
}
const getTotal = (parameter = {}) => {
    return new Promise((resolve, reject) => {
        let url = '/portal/all_metadata_total'
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getPaperDetail = (parameter) => {
    let url = "pid-doi-service/paper.detail?identifier=" + parameter
    return new Promise((resolve, reject) => {
        axios.post(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })

}

const getQuotetail = (params) => {
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/citations/getDataCitations?doi=${params}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getArticle = (params) => {
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/citations/search?identifier=` + params
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getScienceData = (params) => {
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/citations/getDetail?doi=${params}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getPatent = (parameter) => {
    if (!parameter.prefix) {
        parameter.prefix = ''
    } if (!parameter.container) {
        parameter.container = ''
    }
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/patent/metadata.search.aggregation?` + "page=" +
            parameter.pageNumber +
            "&size=" +
            parameter.pageSize +
            "&query=" +
            parameter.container +
            "&year=" +
            parameter.yearName + "&prefix=" + parameter.prefix


        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 获取专利
const getPatentList = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `/pid-common-service/patent/getPatent.by.person?page=${parameter.pageNumber}&size=${parameter.pageSize}&query=${parameter.container}&personIdentifier=${parameter.identifier}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getPatentDetail = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = '/pid-patent-service/detail?identifier=' + parameter
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getDissList = (params) => {
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/dissertation/metadata.search.aggregation?page=${params.pageNumber}&size=${params.pageSize}&query=${params.container}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getDissDetail = (params) => {
    return new Promise((resolve, reject) => {
        let url = `pid-doi-service/dissertation.detail?identifier=${params}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getInforList = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = 'pid-doi-service/pubmed.list?' + "page=" +
            parameter.pageNumber +
            "&size=" +
            parameter.pageSize +
            "&query=" +
            parameter.container
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getInforDetail = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = 'pid-doi-service/pubmed.Detail?identifier=' + parameter

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 最新注册
const getNewRegister = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `portal/laster_metadata_reg_list`

        axios.post(url, parameter).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getMoreNewRegister = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `portal/lastest_registers?page_num=${parameter.page}&page_size=${parameter.size}&title=${parameter.title}`

        axios.get(url, parameter).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 最新解析
const getNewResolve = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `portal/lastestResolveList?page_num=${parameter.page}&page_size=${parameter.size}&title=${parameter.title}`

        axios.get(url, parameter).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 最新引用
const getNewQuote = (parameter) => {

    if (!parameter.title) {
        parameter.title = ""
    }
    return new Promise((resolve, reject) => {
        let url = `portal/quote/list`

        axios.post(url, parameter).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 最高被引
const getHighestReference = (parameter) => {

    if (!parameter.title) {
        parameter.title = ""
    }
    if (!parameter.resourceType) {
        parameter.resourceType = ""
    }
    return new Promise((resolve, reject) => {
        let url = `portal/MostCited?page_num=${parameter.page}&page_size=${parameter.size}&title=${parameter.title}&resourceType=${parameter.resourceType}`

        axios.get(url, parameter).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 获取人员基本信息
const getBasicInfor = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `pid-person-service/person/getPersonInfo?identifier=${parameter}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })


}
// 获取人员论文接口
const getPersonPaper = (parameter) => {
    if (!parameter.database) {
        parameter.database = ''
    }
    if (!parameter.sjr) {
        parameter.sjr = ''
    }
    if (!parameter.jcr) {
        parameter.jcr = ''
    } if (!parameter.type) {
        parameter.type = ''
    }

    return new Promise((resolve, reject) => {
        let url = `pid-doi-service/paper.list?query=${parameter.title}&page=${parameter.pageNumber}&size=${parameter.pageSize}&year=${parameter.year}&identifier=${parameter.parse}` + "&sortFiled=" + parameter.sortFiled + "&order=" + parameter.order + "&database=" + parameter.database + '&SJRRank=' + parameter.sjr + '&JCRRank=' + parameter.jcr + '&type=' + parameter.type
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })


}
// 获取人员列表
const getPersonList = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `pid-person-service/person/getPersonList?page = ${parameter.pageNumber}&size=${parameter.pageSize}& query=${parameter.container}& position=${parameter.position}& company=${parameter.company} `
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })


}
// 门户最新元数据通用接口
const getlasterMetadataList = (type) => {
    return new Promise((resolve, reject) => {
        let url = `portal/laster_metadata_list?type=${type}`

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getResourceTypeRegister = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `portal/static/getYearRegisterCount`

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 每日新增
const addData = (type) => {
    return new Promise((resolve, reject) => {
        let url = `portal/static/getYesterdayRegisterCount`

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

// 
const getPaperBlock = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `pid-doi-service/statisticsRegionAll?identifier=${parameter}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// // 引证文献统计
const getQuoteStaticBlock = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/citations/statisticsRegionAll?identifier=${parameter}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getCitations = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/citations/searchlocal?identifier=` + parameter
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getAlterTic = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `pid-common-service/citations/searchCitationCount?identifier=` + parameter
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
const getNewData = (parameter) => {

    return new Promise((resolve, reject) => {
        //  let url = `pid-common-service/pid.news.admin.list`
        let url = `api/news/list?page_num=${parameter.page}&page_size=${parameter.size}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 新闻详情
const getNewDetail = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `api/news/detail?id=${parameter}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 获取物种名录
const getSpeciesData = (parameter) => {
    return new Promise((resolve, reject) => {
        // let url = `http://10.0.85.131:8000/api/v3/search`
        let url = `api/search`
        axios({
            method: 'post',
            url: url,
            data: parameter
        }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 获取前缀信息
const getPrefix = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `portal/prefix/search?prefix=${parameter}`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
// 获取成员单位
const getOrganList = (parameter) => {
    return new Promise((resolve, reject) => {
        let url = `portal/members/search`
        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}
export default {
    getPaper,
    getArticle,
    getNewData,
    getNewDetail,
    getNewRegister,
    getMoreNewRegister,
    getNewQuote,
    getSpeciesData,
    getQuoteStaticBlock,
    getDissList,
    addData,
    getPatent,
    getResourceTypeRegister,
    getCitations,
    getAlterTic,
    getDissDetail,
    getPatentList,
    getInforList,
    getInforDetail,
    getPersonPaper,
    getPersonList,
    getPaperBlock,
    getBasicInfor,
    getScienceData,
    getPatentDetail,
    getQuotetail,
    getResource, getTotal, getPaperDetail,
    getPrefix,
    getOrganList,
    getlasterMetadataList,
    getNewResolve,
    getHighestReference
}